import { useOktaAuth } from "@okta/okta-react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { ReviewedAccessActions } from "./model";
import { ApplicationListPageActions } from "../../../../applications/applicationList/model";
import { getAppAccessTypeLink } from "../../../../../common/AccessTypeLinks";

export const ReviewedAccessController = (userId, appId) => {
  const { authState } = useOktaAuth();
  const dispatch = useDispatch();

  let columns = [];
  let data = [];
  let progress = true;

  const reviewedAccess = useSelector(
    (rootState) => rootState.reviewedAccesses.reviewedAccesses[userId],
  );
  const {
    value: { data: appsList },
  } = useSelector((rootState) => rootState.applicationList.applicationList);
  useEffect(() => {
    dispatch(ApplicationListPageActions.fetchAppsIfNotPresent());
  }, [dispatch]);
  const appInfo = appsList?.find((app) => app.id === appId);

  if (reviewedAccess) {
    const reviewedAccessesInApp = reviewedAccess.value[appId];
    if (reviewedAccessesInApp) {
      data = reviewedAccessesInApp.datasource;
      columns = reviewedAccessesInApp.columns;
      progress = !!reviewedAccessesInApp.progress;
    }
  }

  useEffect(() => {
    if (authState.isAuthenticated) {
      dispatch(
        ReviewedAccessActions.getReviewedAccess({
          userId: userId,
        }),
      );
    }
  }, [dispatch, authState]);

  return {
    data,
    columns,
    isLoading: progress,
    accessTypeLink: getAppAccessTypeLink(appInfo)?.url
  };
};
